import React from 'react';
import WhiskeyLogo from '../layout/WhiskeyLogo';
import StepIndicator from './StepIndicator';

interface OnboardingShellProps {
  currentStep: number;
  totalSteps: number;
  heading: string;
  subheading: string;
  onContinue: () => void;
  onSkip?: () => void;
  continueLabel?: string;
  continueDisabled?: boolean;
  children: React.ReactNode;
}

const OnboardingShell: React.FC<OnboardingShellProps> = ({
  currentStep, totalSteps, heading, subheading, onContinue, onSkip, continueLabel = 'Continue', continueDisabled, children,
}) => (
  <div className="ws-shell" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 20px', background: 'var(--paper)' }}>
    <div className="ws-fade-up" style={{ width: '100%', maxWidth: 560 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center', marginBottom: 24 }}>
        <WhiskeyLogo size={22} />
        <span className="ws-display" style={{ fontWeight: 700, fontSize: 15, color: 'var(--text-primary)' }}>Whiskey Sensei</span>
      </div>

      <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16, padding: '32px 36px', boxShadow: '0 1px 2px oklch(0.2 0.02 260 / 0.06), 0 12px 32px oklch(0.2 0.02 260 / 0.05)' }}>
        <StepIndicator currentStep={currentStep} totalSteps={totalSteps} />

        <h1 className="ws-display" style={{ margin: '0 0 6px', fontSize: 24, fontWeight: 700, color: 'var(--text-primary)' }}>{heading}</h1>
        <p style={{ margin: '0 0 24px', fontSize: 14, lineHeight: 1.5, color: 'var(--text-tertiary)' }}>{subheading}</p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {children}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 28, gap: 16 }}>
          {onSkip ? (
            <button type="button" onClick={onSkip} style={{ background: 'none', border: 'none', padding: 0, font: 'inherit', fontSize: 13, fontWeight: 600, color: 'var(--text-tertiary)', cursor: 'pointer' }}>
              Skip for now
            </button>
          ) : <span />}
          <button
            type="button"
            onClick={onContinue}
            disabled={continueDisabled}
            className="btn-live"
            style={{
              background: 'var(--ink)', color: 'white', fontWeight: 700, fontSize: 14, padding: '11px 24px', borderRadius: 10,
              border: 'none', cursor: continueDisabled ? 'default' : 'pointer', opacity: continueDisabled ? 0.5 : 1,
              display: 'inline-flex', alignItems: 'center', gap: 8,
            }}
          >
            {continueLabel}
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M7 4l6 6-6 6" /></svg>
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default OnboardingShell;
